import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#280203",
      paper: "#3b0709",
    },
    primary: {
      main: "#ff9c19",
      contrastText: "#1a1a1a",
    },
    secondary: {
      main: "#e2008a",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255, 255, 255, 0.7)",
    },
    divider: "rgba(255, 255, 255, 0.12)",
  },

  typography: {
    fontFamily: `"Poppins", "Roboto", "Helvetica", "Arial", sans-serif`,
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  components: {
    /* -----------------------------------------------------
     * Speed Dial styling starts here
     * ----------------------------------------------------- */
    MuiSpeedDial: {
      styleOverrides: {
        fab: {
          // Main SpeedDial button
          backgroundImage:
            "linear-gradient(0deg, rgb(255,156,25) 40%, rgb(255,221,45) 110%)",
          color: "#1a1a1a",
          "&:hover": {
            backgroundImage:
              "linear-gradient(0deg, rgb(255,176,55) 40%, rgb(255,231,75) 110%)",
          },
        },
      },
    },

    MuiSpeedDialAction: {
      styleOverrides: {
        fab: {
          // Secondary action FABs
          backgroundColor: "#e2008a",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#ff33a6",
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(226, 0, 138, 0.3)",
            color: "rgba(255,255,255,0.4)",
          },
        },

        staticTooltipLabel: {
          backgroundColor: "#3b0709",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.15)",
          fontSize: "0.75rem",
          padding: "6px 10px",
          borderRadius: 8,
        },
      },
    },

    /* -----------------------------------------------------
     * Button Overrides (your original as-is)
     * ----------------------------------------------------- */
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "10px 20px",
          fontWeight: 600,
          transition: "all 0.2s ease-in-out",
        },

        // Gradient primary button
        containedPrimary: {
          color: "#1a1a1a",
          backgroundImage:
            "linear-gradient(0deg, rgb(255,156,25) 40%, rgb(255,221,45) 110%)",
          "&:hover": {
            opacity: 0.9,
            backgroundImage:
              "linear-gradient(0deg, rgb(255,176,55) 40%, rgb(255,231,75) 110%)",
          },
          "&.Mui-disabled": {
            backgroundImage:
              "linear-gradient(0deg, rgba(255,156,25,0.4) 40%, rgba(255,221,45,0.4) 110%)",
            color: "rgba(0,0,0,0.4)",
            opacity: 1,
          },
        },

        // Pink secondary
        containedSecondary: {
          backgroundColor: "#e2008a",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#ff33a6",
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(226, 0, 138, 0.3)",
            color: "rgba(255,255,255,0.4)",
          },
        },

        // Outlined white
        outlined: {
          borderColor: "rgba(255, 255, 255, 0.4)",
          color: "#ffffff",
          "&:hover": {
            borderColor: "rgba(255, 255, 255, 0.7)",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
          },
          "&.Mui-disabled": {
            borderColor: "rgba(255,255,255,0.15)",
            color: "rgba(255,255,255,0.3)",
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          color: "#fff", // text color
        },
        icon: {
          color: "#fff", // icon color
        },
        deleteIcon: {
          color: "#fff",
        },
      },
    },

    /* -----------------------------------------------------
     * Dialog / Paper / Dividers (your original)
     * ----------------------------------------------------- */
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#3b0709",
          borderRadius: 12,
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#3b0709",
          borderRadius: 16,
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(255,255,255,0.15)",
        },
      },
    },
  },
});

export default theme;
